var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"text-xl text-white-1 font-bold"},[_vm._v(_vm._s(_vm.time))]),_c('RecordingState',{staticClass:"mt-1",attrs:{"isRecording":_vm.isRecording,"isPaused":_vm.isPaused}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }